import React, { useState, useEffect } from 'react'
import './index.css'
import { AxiosResponse } from "axios";
import api from '../../Services/api'
import ModalAlert from '../ModalAlert/modal'
import secureLocalStorage from "react-secure-storage";
import Loading from '../Loading';
import { useNavigate } from 'react-router';
import CustomRegistrationModalShell from '../CustomRegistrationForm/CustomRegistrationModalShell'
import ActiveToggleField from '../CustomRegistrationForm/ActiveToggleField'
import '../CustomRegistrationForm/custom-registration-modal.css'
import '../TaskForm/usuario-form.css'

function FormSubGrupoPreventiva(props: any) {

    const navigate = useNavigate();
    const dadosFab = (sessionStorage.getItem("dadosFab") || '{}');
    let userFab = JSON.parse(dadosFab);
    const [id, setId] = useState(userFab.psg_id || '')
    const [active, setActive] = useState(userFab.psg_active != undefined ? Boolean(userFab.psg_active) : true)
    const [description, setDescription] = useState(userFab.psg_description || '')
    const [alternativeIdentifier, setAlternativeIdentifier] = useState(userFab.psg_alternativeidentifier || '')
    const [descriptionIni, setDescriptionIni] = useState(userFab.psg_description || '')
    const [alternativeIdentifierIni, setAlternativeIdentifierIni] = useState(userFab.psg_alternativeidentifier || '')

    const [openModal, setOpenModal] = useState(false)
    const [qualAlert, setQualAlert] = useState(<></>)

    const [optionssubgroupPreventiva, setOptionssubgroupPreventiva] = useState([])

    useEffect(() => {

        validatToken();
    }, []);


    async function validatToken() {

        let ret: AxiosResponse;
        let valor: any;

        const _user = secureLocalStorage.getItem('t')

        api.defaults.headers.common['Authorization'] = _user as ''

        try {

            ret = await api.get("/status/validar")

            if (ret.data.status === 200) {

                secureLocalStorage.setItem('t', ret.data.data);
                secureLocalStorage.setItem('acp', ret.data.decodedToken.acp_integrationid);
                secureLocalStorage.setItem('n', ret.data.decodedToken.name);
                secureLocalStorage.setItem('iag', ret.data.decodedToken.id);
                secureLocalStorage.setItem('cy', ret.data.decodedToken.company);

                GetsubgroupPreventiva()

            }
        } catch (e: any) {

            if (e.response.data.status === 403) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
                    <div className='btn-alert' onClick={fecharModalToken}><span className="btn-alert-lab">OK</span></div>
                </div>)

                setOpenModal(true)

            }
        }

    }

    async function GetsubgroupPreventiva() {
        let ret: AxiosResponse;
        let valor: any;

        try {
            ret = await api.get("preventivesubgroup/listar")
            if (ret.data.status === 200) {
                valor = ret.data.data;

                setOptionssubgroupPreventiva(valor)

            }
        } catch (e) {
            setOptionssubgroupPreventiva([])

        }
    }

    function fecharModalToken() {

        secureLocalStorage.removeItem('t')
        secureLocalStorage.removeItem('acp')
        secureLocalStorage.removeItem('n')
        secureLocalStorage.removeItem('iag')
        navigate('/login');
        setOpenModal(false)

    }

    function ConfirmarContrato() {

        if (id === undefined || id === '') {
            insertContrato();
        } else {
            UpdateContrato();
        }
    }


    function fecharModal() {
        setOpenModal(false)
    }

    async function UpdateContrato() {



        const FiltrarDescricao = optionssubgroupPreventiva.filter(
            (e: any) => {
                return e.psg_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltrarAlternativeIdentifier = optionssubgroupPreventiva.filter(
            (e: any) => {
                return e.psg_alternativeidentifier.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );


        if (descriptionIni.toLowerCase() !== description.toLowerCase() && FiltrarDescricao.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">Descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
        } else
            if (description === "") {
                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)
                setOpenModal(true)
            } else
                if (alternativeIdentifier === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                } else if (alternativeIdentifierIni.toLowerCase() !== alternativeIdentifier.toLowerCase() && FiltrarAlternativeIdentifier.length > 0) {

                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Identificador alternativo já está em uso.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }

                else {

                    let ret: AxiosResponse;
                    const dados = {
                        psg_id: id,
                        psg_active: active,
                        psg_description: description,
                        psg_alternativeidentifier: alternativeIdentifier,
                    }
                
                    try {
                        ret = await api.put("preventivesubgroup/update", {
                            data: dados,
                        });
                        if (ret.data.status === 200) {
                            props.voltar()
                        }
                    } catch (e: any) {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Não foi possível concluir a alteração.</span></div>
                            <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                        </div>)
                    setOpenModal(true)
                    }
                }

    }

    async function insertContrato() {
        let ret: AxiosResponse;


        const FiltrarDescricao = optionssubgroupPreventiva.filter(
            (e: any) => {
                return e.psg_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltrarAlternativeIdentifier = optionssubgroupPreventiva.filter(
            (e: any) => {
                return e.psg_alternativeidentifier.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );


        if (FiltrarDescricao.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">Descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
        } else
            if (description === "") {
                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)
                setOpenModal(true)
            } else
                if (alternativeIdentifier === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                } else if (FiltrarAlternativeIdentifier.length > 0) {

                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Identificador alternativo já está em uso.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }

                else {
                    const dados = [{
                        psg_active: active,
                        psg_description: description,
                        psg_alternativeidentifier: alternativeIdentifier,
                    }]

                    try {
                        ret = await api.post("preventivesubgroup/insert", {
                            data: dados,
                        });

                        if (ret.data.status === 200) {
                            props.voltar()
                        }
                    } catch (e: any) {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Não foi possivel concluir o cadastramento.</span></div>
                            <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                        </div>)

                        setOpenModal(true)
                    }
                }
    }

    function ValitarActive() {
        let e = document.getElementById("checkbox-active") as HTMLInputElement;

        if (e.checked) {

            setActive(true)
        } else {

            setActive(false)
        }
    }


    function voltar() {

        props.voltar();

    }

    return (
        <>
            <CustomRegistrationModalShell
                mode={id ? 'edit' : 'add'}
                recordId={id ? String(id) : undefined}
                title={id ? 'Editar Subgrupo Preventiva' : 'Cadastrar Subgrupo Preventiva'}
                subtitle="Classificação de subgrupos para tipos de manutenção preventiva."
                onCancel={props.voltar}
                onSave={ConfirmarContrato}
            >
                <ActiveToggleField active={active} onChange={setActive} />

                <div className="usuario-form__grid usuario-form__grid--2">
                    <div className="usuario-form__field">
                        <label className="usuario-form__label usuario-form__label--required">Descrição</label>
                        <input
                            className="usuario-form__input"
                            autoComplete="off"
                            type="text"
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />
                    </div>
                    <div className="usuario-form__field">
                        <label className="usuario-form__label usuario-form__label--required">
                            Identificador Alternativo
                        </label>
                        <input
                            className="usuario-form__input"
                            autoComplete="off"
                            type="text"
                            onChange={(e) => setAlternativeIdentifier(e.target.value)}
                            value={alternativeIdentifier}
                        />
                    </div>
                </div>
            </CustomRegistrationModalShell>

            <ModalAlert isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
                <div className='container-modal-alert'>
                    {qualAlert}
                </div>
            </ModalAlert>
        </>
    );

}

export default FormSubGrupoPreventiva;